import React from "react";
import { useTranslation } from "react-i18next";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useSnapshot } from "valtio";
import { store as defaultSettingStore } from "./DefaultModalContentWrapper/store";
import {
    getPeripheralTypes,
    parseApplicationsText,
    transformData,
} from "@helpers/general";
import { toast } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { mutate } from "swr";
import { store } from "@components/VerticalLayout/store";
import { fetchGlobal } from "../../../api/hooks";

export function SaveButtonComponent({
    setIsOpen,
    isOpen,
    setIsConfigurationModalOpened,
    setIsLoading,
    filteredTva,
    filteredSaleMode,
    filteredLanguage,
    filteredSaleSupport,
    filteredPaymentMethod,
    filteredCurrency,
    applicationsClass,
    applicationsText,
    peripheralClass,
    peripheralText,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: any) {
    const { t } = useTranslation();
    const { defaultSetting } = useSnapshot(defaultSettingStore);
    const { userID, franchiseID, operatorID, oneShop, shopID } = useSnapshot(
        store
    );
    const uuidUser = localStorage.getItem("uuidUser");

    async function deleteDefaultSetting() {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/deleteData?franchiseId=${franchiseID}`;
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };
        try {
            const data = await fetchGlobal<any>(apiUrl, requestOptions);

            if (data.error) {
                throw Error("error");
            }

            mutate(apiUrl, data);
        } catch (e) {}
    }
    async function handleApplicationValidateButtonClickEvent() {
        setIsOpen(!isOpen);
        setIsConfigurationModalOpened(false);
        setIsModalLoadingOpened(true);
        setModalLoadingData({
            title: "Default configuration in progress",
            message: "The default configuration is currently in progress.",
        });
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting`;
        const { kioskCount, kdsCount } = parseApplicationsText(
            applicationsText
        );

        const peripheral = getPeripheralTypes(
            defaultSetting.peripheral?.data || []
        );

        let savedData = {
            userId: userID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            franchiseId: franchiseID,
            shopId: oneShop ? shopID : "0",

            defaultSetting: {
                tva: filteredTva,
                language: transformData(filteredLanguage),
                saleMode: transformData(filteredSaleMode),
                saleSupport: transformData(filteredSaleSupport),
                paymentMethod: transformData(filteredPaymentMethod),
                currency: transformData(filteredCurrency),
                ...(applicationsText !== "vide" && {
                    kioskCount: kioskCount,
                    kdsCount: kdsCount,
                }),
                ...(peripheralText !== "vide" && {
                    peripheral: peripheral,
                }),
            },
        };
        try {
            const data = await fetchGlobal<any>(apiUrlAdd, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bareer ${localStorage.getItem("jwt")}`,
                },
                body: JSON.stringify(savedData),
                method: "POST",
            });

            if (data.error) {
                throw Error("Error while saving selection!");
            }

            deleteDefaultSetting();
            toast.success(
                `${t(
                    "The default configuration has been successfully applied."
                )}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: (
                        <CheckboxIcon
                            height={25}
                            width={25}
                            fill="white"
                        />
                    ),
                }
            );
            setIsLoading(false);
            setIsModalLoadingOpened(false);
            mutate(apiUrlAdd, data);
        } catch (e: any) {
            toast.error(`${t("Mistake ! Please try again")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsModalLoadingOpened(false);
        }
    }

    return (
        <CustomMainColorButton
            className="w-20 kds_btn_validateTemplate"
            rounded
            variant="primary"
            onClick={() => {
                handleApplicationValidateButtonClickEvent();
            }}
        >
            {t("Save")}
        </CustomMainColorButton>
    );
}
